import { memo } from 'react';
import { ActionButton } from './ActionButton';

const ConfigField = memo(({
    label,
    name,
    type = "number",
    placeholder,
    register,
    errors,
    min = 0,
    options = null,
    setValue = null,
    isUpdating = false
}) => {
    return (
        <div className='mt-2'>
            <p className="text-base text-primary font-bold">{label}</p>
            <div className={`flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border ${errors[name] ? 'border-red' : 'border-border'} text-slate-400`}>
                {type === 'select' ? (
                    <select
                        name={name}
                        id={name}
                        {...register(name, { required: false })}
                        className="flex-1 shrink self-stretch my-auto basis-0 outline-none px-4 py-2.5 rounded-md text-base"
                        onChange={(e) => setValue && setValue(name, e.target.value)}
                    >
                        {options?.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                ) : (
                    <input
                        type={type}
                        name={name}
                        id={name}
                        {...register(name, {
                            required: `${label} is required`,
                            min: type === 'number' ? min : undefined
                        })}
                        placeholder={placeholder || label}
                        className="flex-1 shrink self-stretch my-auto basis-0 outline-none px-4 py-2.5 rounded-md text-base"
                        min={type === 'number' ? min : undefined}
                    />
                )}
            </div>
            {errors[name] && (
                <p className="text-red text-sm mt-1">
                    {errors[name].message || "This field is required"}
                </p>
            )}
        </div>
    );
});

ConfigField.displayName = 'ConfigField';

export default ConfigField;
